/*
 * Copyright (c) 2022. Revo Digital
 * ---
 * Author: gabriele
 * File: HistoryView.tsx
 * Project: mle-client-n
 * Committed last: 2022/1/14 @ 111
 * ---
 * Description:
 */

import { Editor }                     from '../../../store/observables/Editor';
import { Callout, Card, Intent, Tag } from '@blueprintjs/core';
import { observer }                   from 'mobx-react';
import classNames                     from 'classnames';
import { currentThemeIsDark }         from '../../../common/utils';

interface HistoryViewProps {
  editor: Editor;
}

export const HistoryView = observer((props: HistoryViewProps) => {
  return (<div className="overflow-auto">
    <Callout className="text-xs mb-2">
      Premi su una modifica registrata per ripristinare l&apos;area di lavoro
      allo stato di quel momento
    </Callout>
    {
      props.editor.history.mementos.length ? props.editor.history.mementos.slice().reverse().map(
        (memento, index) =>
          <div>
            <Card
              className="p-2 mb-2 cursor-pointer hover:bg-bpblue-500 hover:border-bpblue-300 focus:border focus:border-bpblue-500"
              onClick={ () => props.editor.restore(memento.state) }
            >
              <div><strong><span
                className="text-xs bp4-text-muted">#{ index + 1 }  </span>{ memento.date.toLocaleTimeString(
                'it-IT') }</strong>
                { index === 0 &&
                  <Tag className="ml-2" intent={ Intent.PRIMARY } minimal>
                    Ultima
                  </Tag> }
              </div>
              <div
                className="text-xs bp4-text-muted">Modifica &bull; { memento.date.toLocaleDateString(
                'it-IT') }</div>
            </Card>
          </div>
      ) : <div
        className={ classNames(
          'mb-4 p-2 rounded flex flex-row align-middle gap-x-2',
          {
            'bg-bpdisabled-light': !currentThemeIsDark(),
            'bg-bpdisabled-dark': currentThemeIsDark()
          }) }>Nessuno stato registrato</div>
    }
  </div>);
});
